module.exports = __webpack_public_path__ + "static/media/DSC_0038.cd2f46ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0038.jpg
// module id = 546
// module chunks = 0